module.exports = __webpack_public_path__ + "img/filter-gray.6c0804a7.svg";